import { GetObjectCommand, S3Client } from "@aws-sdk/client-s3";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-provider-cognito-identity";
import { getSignedUrl } from "@aws-sdk/s3-request-presigner";
import { Box, CircularProgress, Container, FormControl, Grid, makeStyles, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@material-ui/core";
import { useEffect, useState } from "react";
import { APIHandler } from "../../common/APIHandler/APIHandler";
import { useLocation, useNavigate } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
    content: {
        marginTop: 'auto',
        flexGrow: 1,
    },
    menu: {
        maxHeight: 500
    },
}));

const fetchStorylineData = async () => {
    const bucketName = "kong-dev-thumbnails";
    const dataKey = "kong-demo-storylines.json";
    const region = process.env.REACT_APP_REGION;
    const identityPoolId = process.env.REACT_APP_IDENTITY_POOL_ID;
    const userPoolId = process.env.REACT_APP_USER_POOL_ID
    const idToken = sessionStorage.getItem("idToken");

    const s3Client = new S3Client({
        region,
        credentials: fromCognitoIdentityPool({
            clientConfig: { region },
            identityPoolId,
            logins: {
                [`cognito-idp.${region}.amazonaws.com/${userPoolId}`]: idToken,
            },
        }),
    });

    const command = new GetObjectCommand({
        Bucket: bucketName,
        Key: dataKey,
    });

    const url = await getSignedUrl(s3Client, command, { expiresIn: 300 });
    return fetch(url, { headers: { 'Content-Type': 'application/json' } });
}

export const StorylineList = () => {
    const classes = useStyles();

    const navigate = useNavigate();
    const { state } = useLocation();

    const { query } = APIHandler();
    const [topics, setTopics] = useState();
    const [selectedTopicId, setSelectedTopicId] = useState("");
    const [selectedTopic, setSelectedTopic] = useState();

    const selectTopic = (topicId, topicsToSearch) => {
        setSelectedTopicId(topicId);
        setSelectedTopic(topicsToSearch.find(topic => topic.id === topicId));
    }

    useEffect(() => {
        const topicsPromise = fetchStorylineData()
            .then(resp => resp.json());
        const eventsPromise = fetchEventData().then(resp => resp.data);
        Promise.all([topicsPromise, eventsPromise]).then(([storylineTopics, events]) => {
            const matchedTopics = storylineTopics.map(topic => {
                if (topic.cross_event_topic) {
                    return {
                        ...topic,
                        label: topic.cross_event_topic,
                    }
                } else if (topic.event) {
                    // otherwise, match event to topic
                    const matchedEvent = events.find(event => {
                        return topic.event.game_type === event.Variables.game_type
                            && topic.event.home_team === event.Variables.home_team
                            && topic.event.away_team === event.Variables.away_team
                            && (
                                !topic.event.title_contains
                                || topic.event.title_contains.every(
                                    term => event.Name.toLowerCase().includes(term.toLowerCase())
                                )
                            )
                    });
                    if (!matchedEvent) return null;
                    return {
                        ...topic,
                        label: matchedEvent.Name,
                    }
                }
            }).filter(Boolean);
            setTopics(matchedTopics);
            if (state.data?.event) {
                const preSelectedTopic = matchedTopics.find(topic => topic.label === state.data?.event.Name);
                if (preSelectedTopic) selectTopic(preSelectedTopic.id, matchedTopics);
            }
        });
    }, []);

    const fetchEventData = () => {
        return query("get", "api", "event/all", {
            queryParams: {
                Status: "Complete",
                ProjectionExpression: "Name, Program, Variables",
            },
        });
    };

    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                <Typography variant="h1">Storylines</Typography>
                <FormControl variant="outlined" size="small">
                    {!topics ?
                        <Container>
                            <CircularProgress color="inherit" />
                        </Container> :
                        <Select
                            value={selectedTopicId}
                            onChange={(event) => selectTopic(event.target.value, topics)}
                            MenuProps={{ classes: { paper: classes.menu } }}
                        >
                            {topics.map(topic =>
                                <MenuItem key={topic.id} value={topic.id}>{topic.label}</MenuItem>
                            )}
                        </Select>
                    }
                </FormControl>
            </Box>
            {selectedTopic &&
                <Paper>
                    <TableContainer className={classes.content}>
                        <Table stickyHeader>
                            <TableHead style={{ tableLayout: "auto" }}>
                                <TableRow>
                                    <TableCell>
                                        <Typography variant="h2">{selectedTopic.headline}</Typography>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {selectedTopic.storylines.map(item =>
                                    <TableRow key={item} hover>
                                        <TableCell>{item}</TableCell>
                                    </TableRow>
                                )}

                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            }
        </Box>
    );
}